<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/keuken/Asset 66.png" alt="">
    
    <span v-show="selected_text == -1">
      <img draggable="false" id="wood_pallets" src="./../../assets/images/keuken/Asset 61.png">
      <img draggable="false" id="text_pallet" src="./../../assets/images/keuken/Asset 60.png">
      <img draggable="false" class="clickable" id="keuken_play_btn" @click="showText()" src="./../../assets/images/Asset 57.png" alt="">
    </span>

    <span v-show="selected_text >= 0">
      <span v-if="selected_text == 0" id="eid_game_text">Ireen’s alakondre Kukru</span>
      <span v-html="texts[selected_text]" id="marron_game_intro_text" :style="selected_text > 0 ? 'margin-top: 7%;' : ''"></span>
      <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../../assets/images/Asset 51.png" alt="">
      <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../../assets/images/Asset 51.png" alt="">
    </span>
    
  </span>
</template>

<script>


export default {
  name: "KeukenStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: -1,
      texts: [
        "“A no alaboriman abi na leti fu kar eng srefi koki”( Niet eenieder die kookt heeft het recht zich kok te noemen). <br><br> Ireen, naar wie onze alakondre kukru is vernoemd, heeft het recht verdiend zich kok te noemen. Wie is Ireen? <br><br> Van jongs af aan was Ireen verplicht te koken. Zelfs als het gerecht niet een succes was werd het opgegeten. De moeder van Ireen had een Warung (dit is een eetstand waar er overwegend Javaanse gerechten verkocht worden). Ireen hield niet van koken echter was ze verplicht mee te kijken hoe de verschillende Javaanse gerechten klaargemaakt werden.",

        "Na een administratieve baan te hebben opgezegd is ze gestart met haar eigen warung.De Javaanse gerechten waren haar specialiteit. Ze bleef experimenteren met de Javaanse keuken. Ireen past het principe ‘learning by doing’ toe. Na het openen van haar Warung, bleef ze zich verdiepen in de rest van de Surinaamse keuken. De Surinaamse keuken is heel divers en Ireen heeft van verschillende plekken inspiratie gekregen. Heden ten dage is zij ook bekend met de Creoolse, Hindoestaanse, Chinese en Europese keuken.Nu al langer dan 20 jaar is Ireen bezig met het koken.",

        "Als ze niet kookt geeft ze kookworkshops aan buitenlanders. Het Surinaams eten uitdragen door het te bereiden en presenteren op de authentieke manier is haar missie. “Je hoeft niet te veel kruiden te gebruiken om een gerecht lekker te laten smaken. Soms is tomaat en soepgroenten in een gerecht al heel lekker.” zegt Ireen.In onze alakondre kukru deelt Ireen een van haar recepten met ons.",

        "<u>Recept voor flesjes van Ireen:</u><br><br><ul><li>- 250 gram blom </li><li>- 200 gram geraspte kokos </li><li>- 300 ml water </li><li>- 2 eieren </li><li>- 150 gram bruine suiker </li><li>- 1 theelepel kaneel </li><li>- rode kleurstof of kola essence </li></ul>"
      ]
    };
  },

  methods: {
    goToStart() {
      this.$router.push('/start');
    },

    showText() {
      this.selected_text = 0
    },

    nextText() {
      this.selected_text++;
    },

    prevText() {
      this.selected_text--;
    },
  },

  computed: {}
};
</script>

<style>
  #eid_game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 50%;
    left: 25%;
    color: white;
    font-size: 4vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #keuken_play_btn {
    position: absolute;
    margin-top: 36%;
    left: 42.8%;
    width: 15%;
  }
  #wood_pallets {
    position: absolute;
    margin-top: 5%;
    left: 37.2%;
    width: 25%;
  }
  #text_pallet {
    position: absolute;
    margin-top: 14.5%;
    left: 38%;
    width: 24%;
  }
</style>


